// src\stores\loadingSlice.tsx
import { createSlice } from '@reduxjs/toolkit';

interface LoadingState {
  activeRequests: number;
}

const initialState: LoadingState = {
  activeRequests: 0,
};

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    incrementActiveRequests: (state) => {
      state.activeRequests += 1;
    },
    decrementActiveRequests: (state) => {
      state.activeRequests = Math.max(state.activeRequests - 1, 0);
    },
  },
});

export const { incrementActiveRequests, decrementActiveRequests } = loadingSlice.actions;
export default loadingSlice.reducer;
